import React, { memo } from 'react';
import ActionTwoHopPodDevicesDropdownContainer from '../ActionTwoHopPodDevicesDropdownContainer/ActionTwoHopPodDevicesDropdownContainer';
import '../ActionTwoHopProgressViewModal.css';

const ActionTwoHopModalHeaderContainer = (props) => {
  return (
    <div id="ActionTwoHopProgressViewModal_Header_Container" className="ActionTwoHopProgressViewModal_Header_Container">
      <div id="ActionTwoHopProgressViewModal_Header_Title" className="ActionTwoHopProgressViewModal_Header_Title">
        Two-Hop Alignment Progress Status
      </div>
      <ActionTwoHopPodDevicesDropdownContainer
        podOneDevices={props.podOneDevices}
        podTwoDevices={props.podTwoDevices}
        podNameOne={props.podNameOne}
        podNameTwo={props.podNameTwo}
        searchTwoHopDevicesStatus={props.searchTwoHopDevicesStatus}
      />
    </div>
  );
};

export default memo(ActionTwoHopModalHeaderContainer);
